<template>
  <AuthLayout
    active-tab="login"
    :show-tabs="false"
    :title="`${$cte('passwordReset.newPassword')}<br><span>${$cte('passwordReset.enterNewPassword')}</span>`"
  >
    <form class="auth-form reset-form font-poppins">
      <div class="auth-field">
        <label for="login-password">{{ $cte("login.password") }}</label>
        <input
          v-model="password"
          type="password"
          id="login-password"
          :placeholder="$cte('login.password')"
          autocomplete="new-password"
          required
        />
      </div>

      <div class="auth-field">
        <label for="login-password2">{{ $cte("login.passwordAgain") }}</label>
        <input
          v-model="password2"
          type="password"
          id="login-password2"
          :placeholder="$cte('login.password')"
          autocomplete="new-password"
          required
        />
      </div>

      <button class="auth-submit" type="button" @click="newPassword">
        {{ $cte("passwordReset.resetPassword") }}
      </button>
    </form>
  </AuthLayout>
</template>

<script>
import Api from "api-client";
import AuthLayout from "@/components/AuthLayout.vue";

export default {
  name: "NewPassword",
  components: { AuthLayout },
  data() {
    return {
      password: "",
      password2: "",
      urlToken: "",
    };
  },
  created() {
    this.urlToken = this.$route.query.token;
  },
  methods: {
    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    login(self, auth) {
      self.$store.dispatch("login/login", auth);
      self.$router.push("app/home");
    },
    newPassword() {
      let self = this;

      if (self.password === self.password2) {
        Api.setNewPassword(self.urlToken, self.password)
          .then((resp) => {
            if (resp.status !== 200) {
              self.$toast.error({
                title: self.$cte("login.failedPasswordChange"),
                message: self.$cte("login.failedPasswordChange"),
              });
            } else {
              // some hideous glue code
              let auth = 'Bearer ' + resp.data.jwtToken;

              this.afterSuccessFulLogin(auth, false);
            }
          })
          .catch(() => {
            self.$toast.error({
              title: self.$cte("login.failedPasswordChange"),
              message: self.$cte("login.failedPasswordChange"),
            });
          });
      } else {
        self.$toast.error({
          title: self.$cte("common.error"),
          message: self.$cte("login.passwordMatchIssue"),
        });
      }
    },

    //Ezt a Login.vue-bol masoltam ide (Mivel a PWA napjai meg vannak szamlalva, nem fejtem meg mi ez es mit csinal,
    // csak elhiszem hogy talan jo, IDK)
    afterSuccessFulLogin(auth, isAutoLogin) {
      let self = this;
      Api.getMyEnabledCompanies()
          .then((companyResponse) => {
            self.$store.dispatch("app/addCompanyList", companyResponse.data);
            document.title = "Acounto";
            self.$router.push("/app/home/" + new Date().valueOf());
          })
          .catch(() => {
            !isAutoLogin
                ? self.$toast.error({
                  title: self.$cte("login.companiesQueryFailedTitle"),
                  message: self.$cte("login.companiesQueryFailedMessage"),
                })
                : null;
          });
      self.$store.dispatch("login/login", auth);


    },
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 577px) {
  ::v-deep(.auth-title) {
    margin-top: 40px;
  }
}

::v-deep(.auth-title span) {
  display: inline-block;
  margin-top: 14px;
  font-family: Poppins, sans-serif;
  font-size: clamp(16px, 1.2vw, 22px);
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.35;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.auth-field label {
  display: block;
  margin: 0 0 10px 24px;
  color: #000 !important;
  font-family: JumperLight, sans-serif;
  font-size: 16px;
  line-height: 1;
}

.auth-field input,
#app .auth-field input {
  width: 100%;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 20px !important;
  border: 1px solid #aebfc7 !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif;
  font-size: 15px !important;
}

.auth-submit {
  width: 100%;
  min-height: 60px;
  margin-top: clamp(28px, 5vh, 44px);
  border: 0;
  border-radius: 999px;
  background: #b2ec5d;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
  color: #252734;
  font-family: JumperLight, sans-serif;
  font-size: clamp(24px, 1.8vw, 32px);
  line-height: 1;
}

@media (max-width: 576px) {
  .reset-copy {
    margin: 0 0 22px;
  }

  .reset-copy h2 {
    font-size: 28px;
  }

  .reset-copy p {
    font-size: 15px;
  }

  .auth-field label {
    margin-left: 16px;
    margin-right: 16px;
    font-size: 16px;
  }

  .auth-submit {
    min-height: 70px;
    margin-top: 32px;
  }
}
</style>
